var dropdownElem = document.querySelector('.geopopup__country_selector');
var HeaderElem = document.querySelector('.geopopup__modal-header');
var bodyText = document.querySelector('.geopopup__modal-body-text');
var footerlabel = document.querySelector("#footer_dropdown_label_text");
document.querySelector('.geopopup__dropdown_label').addEventListener('click',function (e){
  if (dropdownElem.style.display=='none'){
    dropdownElem.style.display = 'inline';
    this.innerHTML = "Cancel";
    HeaderElem.style.display = 'none';
    bodyText.style.display = "none";
    footerlabel.style.display = "block";
    document.querySelector('.geopopup__newbtn').style.display = 'block';
    document.querySelector("#geopopup__confirm-button").style.display = 'none';
  }else {
    dropdownElem.style.display = 'none';
    this.innerHTML = this.getAttribute('data-text');
    HeaderElem.style.display = 'block';
    bodyText.style.display = 'block';
    footerlabel.style.display = "none";
    document.querySelector('.geopopup__newbtn').style.display = 'none';
    document.querySelector("#geopopup__confirm-button").style.display = 'block';
  }
});
var dropdownElem = document.querySelector('.geopopup__country_selector');
var totalrules = dropdownElem.querySelectorAll('option');
var preserveRelativeUrl = window.location.pathname;
var RedirectBtn = document.querySelector('.geopopup__newbtn');
dropdownElem.addEventListener('change',function (){
  var changeskipurl = new URL(this.options[this.selectedIndex].value);
  var ifruleispreserve = this.options[this.selectedIndex].classList.contains('geopopup__preserve_relative');
  if (ifruleispreserve){
    if (changeskipurl.search.length > 0){
        RedirectBtn.href = changeskipurl.origin + preserveRelativeUrl + changeskipurl.search;
    } else {
        RedirectBtn.href = this.value + preserveRelativeUrl;
    }
  }else {
    RedirectBtn.href = this.value;
  }
});
function geopopupClose(){
  document.querySelector(".geopopup__modal").classList.remove('geopopup__modal--visible')
}
var CloseBtn = document.querySelector('.geopopup__dismiss')
CloseBtn.addEventListener('click', geopopupClose);
/*
var skipurl = new URL(dropdownElem.options[dropdownElem.selectedIndex].value);
if (dropdownElem.options[dropdownElem.selectedIndex].classList.contains('geopopup__preserve_relative')){
    if (skipurl.search.length > 0 ){
        RedirectBtn.href = skipurl.origin + preserveRelativeUrl + skipurl.search;
    }else {
        RedirectBtn.href = dropdownElem.options[dropdownElem.selectedIndex].value + preserveRelativeUrl;
    }
}else {
    RedirectBtn.href = dropdownElem.options[dropdownElem.selectedIndex].value;
}
*/


// Function to show the popup based on geolocation and current market
function handleGeoPopup(data) {
    const currentMarket = data.currentMarket;
    const geolocationPopupRedirects = data.geolocationPopupRedirects;

    // Validate data
    if (!currentMarket || currentMarket === "null") {
        console.warn("Geopopup: currentMarket is not set or invalid.");
        return;
    }

    if (!Array.isArray(geolocationPopupRedirects) || geolocationPopupRedirects.length === 0) {
        console.warn("Geopopup: No geolocation popup redirects found.");
        return;
    }

    const urlParams = new URLSearchParams(window.location.search);

    if(urlParams.get('geopopup') === 'yes' || urlParams.get('geotest') === 'yes'){
      //show the popup even if the cookie is set and the URL parameter src=yes
      if(urlParams.get('geotest') === 'yes') document.querySelector(".geopopup__modal").classList.remove('geopopup__modal--hidden')
    } else {
      //dont show the popup if it has been displayed recently
      if(document.cookie.includes("geopopup_shown=true") ){
        console.warn("Geopopup has already been displayed recently in this domain");
        return;
      }
  
      //if there is a src=yes parameter in the URL, do not show the popup
      if(urlParams.get('src') === 'yes') {
        // Set the cookie to prevent repeated popups
        document.cookie = "geopopup_shown=true; path=/; max-age=" + 30 * 24 * 60 * 60;
        return;
      }
    }

    // Fetch geolocation details using the Shopify browsing_context_suggestions API
    fetch(
        `${window.Shopify.routes.root}browsing_context_suggestions.json?country[enabled]=true&country[exclude]=${window.Shopify.country}&language[enabled]=true&language[exclude]=${window.Shopify.language}`
    )
        .then((response) => response.json())
        .then((geoData) => {
            let currentGeolocation = geoData.detected_values.country.handle;
            if(urlParams.get('geoloc')){
              currentGeolocation = urlParams.get('geoloc');
            }
            //currentGeolocation = "US"

            // Validate response from the API
            if (!currentGeolocation) {
                console.warn("Geopopup: Unable to determine user's geolocation.");
                return;
            }

            // Find a matching geolocation popup redirect
            const match = geolocationPopupRedirects.find((redirect) => {
                const locationCondition = redirect.location_condition;
                const userLocationCode = redirect.user_location_country_code;
                const selectedMarketCondition = redirect.selected_market_condition;
                const selectedMarketCountry = redirect.selected_market_country;

                const locationMatches =
                    (locationCondition === "equals to" &&
                        userLocationCode === currentGeolocation) ||
                    (locationCondition === "not equal to" &&
                        userLocationCode !== currentGeolocation);

                const marketMatches =
                    (selectedMarketCondition === "equals to" &&
                        selectedMarketCountry === currentMarket) ||
                    (selectedMarketCondition === "not equal to" &&
                        selectedMarketCountry !== currentMarket);

                return locationMatches && marketMatches;
            });

            console.log('match', match)

            // If a match is found and conditions are met, display the popup
            if (match) {
            //if(true){
                // Set the cookie to prevent repeated popups
                document.cookie = "geopopup_shown=true; path=/; max-age=" + 30 * 24 * 60 * 60;

                // Fill and show the popup
                document.querySelector(".geopopup__header_img").src = match.image || "";
                document.querySelector(".geopopup__modal-header-text").innerHTML = match.popup_title || "";
                document.querySelector(".geopopup__modal-body-text").innerHTML = match.popup_text || "";
                if(match.button_action == "Close popup"){
                  document.querySelector("#geopopup__confirm-button").href = "#";
                  document.querySelector("#geopopup__confirm-button").addEventListener('click', (e) => {
                    e.preventDefault();
                    geopopupClose();
                  })
                } else {
                  console.log('redirect_url',match.redirect_url)
                  document.querySelector("#geopopup__confirm-button").href = match.redirect_url || "#";
                }                
                document.querySelector("#geopopup__confirm-button").textContent = match.button_label || "Shop Now";

                // Show the popup
                document.querySelector(".geopopup__modal").classList.add('geopopup__modal--visible')
            }
        })
        .catch((error) => {
            console.error("Error fetching geolocation data:", error);
        });
}

// Call the function with data from Liquid
document.addEventListener("DOMContentLoaded", () => {
    const geoPopupData = JSON.parse(document.querySelector("#geopopup-data").textContent);
    console.log("Geo Popup Data:", geoPopupData);
    handleGeoPopup(geoPopupData);
});

